namespace GeniuzPOS.Member {
    export interface PsMeberStatusForm {
        MbCardStatus: Serenity.StringEditor;
        MbCardStatuName: Serenity.StringEditor;
    }

    export class PsMeberStatusForm extends Serenity.PrefixedContext {
        static formKey = 'Member.PsMeberStatus';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsMeberStatusForm.init)  {
                PsMeberStatusForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(PsMeberStatusForm, [
                    'MbCardStatus', w0,
                    'MbCardStatuName', w0
                ]);
            }
        }
    }
}
